import {
    MATTER_TYPE_LABELS,
    PRACTICE_AREA_LABELS,
    type MatterType,
    type PracticeArea,
} from './enums';
import type { RichTextValue } from './types/richText';
import type { UserWithLawFirm } from './types/users';

export const EMPTY_RICH_TEXT_VALUE: RichTextValue = [
    {
        type: 'paragraph',
        children: [{ text: '' }],
    },
];

export function getMatterTypeLabel(matterType?: string | null): string {
    if (!matterType) return '';
    return MATTER_TYPE_LABELS[matterType as MatterType] ?? matterType;
}

export function getPracticeAreaLabel(practiceArea?: string | null): string {
    if (!practiceArea) return '';
    return PRACTICE_AREA_LABELS[practiceArea as PracticeArea] ?? practiceArea;
}

export function getIntakeFormTitle(matterType?: string | null): string {
    const label = getMatterTypeLabel(matterType);
    const suffix = label.endsWith('Intake') ? ' Form' : ' Intake Form';
    return `${label}${suffix}`.trim();
}

export function convertPlainTextToRichText(text: string | null | undefined): RichTextValue {
    if (text == null) return EMPTY_RICH_TEXT_VALUE;

    const paragraphs: RichTextValue = text.split('\n').map((line) => ({
        type: 'paragraph',
        children: [{ text: line }],
    }));

    return paragraphs.length ? paragraphs : EMPTY_RICH_TEXT_VALUE;
}

export function getSignatureValue(
    user: Pick<UserWithLawFirm, 'signature' | 'signatureJson'> | null,
): RichTextValue {
    if (user?.signatureJson?.length) {
        return user.signatureJson;
    }

    return convertPlainTextToRichText(user?.signature ?? null);
}
